import React from 'react';
import styles from './SignInContainerLayout.module.css';
import { ContentLayout } from '@amzn/awsui-components-react';

const SignInContainerLayout = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.container}>
    {' '}
    <ContentLayout>{children} </ContentLayout>
  </div>
);

export default SignInContainerLayout;
